<template>
    <div class="select-version">
        <div class="select-version__info">
            Which version {{ examName }} is right for you? You can change your exam version at any time in settings.
        </div>
        <div class="select-version__versions">
            <ExamVersionCard
                v-for="(exam, index) in examVersions"
                :key="exam.objectId"
                :exam="exam"
                :adding-exam="true"
                :is-selected-version="selectedVersion === exam.version"
                :is-latest-version="index === 0"
                @clickExamVersion="selectVersion"
            />
        </div>
        <div class="select-version__buttons">
            <PocketButton
                class="select-version__submit"
                :disabled="!selectedVersion"
                @click="emitNext"
            >
                Continue<Icon class="select-version__submit-arrow" type="arrow" />
            </PocketButton>
        </div>
        <PhonePerson
            v-if="bundleId"
            class="select-version__phone-person"
            :bundle-id="bundleId"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import type { Study } from '@pocketprep/types'
import type { ClientBundle, ClientExam } from '@/store/bundle/state'
import UIKit from '@pocketprep/ui-kit'
import ExamVersionCard from '@/components/Settings/EditExam/ExamVersionCard.vue'
import { examVersionNativeAppName } from '@/utils'

const {
    Button: PocketButton,
    PhonePerson,
    Icon,
} = UIKit

const props = defineProps<{
    examVersions: (Study.Class.ExamMetadataJSON | ClientExam)[]
    bundle: Study.Class.BundleJSON | ClientBundle
    currentExam: Study.Class.ExamMetadataJSON | ClientExam
}>()

const emit = defineEmits<{
    cancel: [value: boolean]
    next: [value: boolean]
    selectExamVersion: [exam: Study.Class.ExamMetadataJSON | ClientExam]
}>()

const selectedVersion = ref<string | null>(null)
const examName = ref('')

const bundleId = computed(() => {
    return props.bundle.objectId
})

const selectVersion = (examParam: Study.Class.ExamMetadataJSON | ClientExam) => {
    selectedVersion.value = examParam.version
    emitSelectExamVersion(examParam)
}

onMounted(() => {
    examName.value = examVersionNativeAppName(props.currentExam.nativeAppName)
})

const emitNext = () => {
    emit('next', true)
}

const emitSelectExamVersion = (emitExamParam: Study.Class.ExamMetadataJSON | ClientExam) => {
    emit('selectExamVersion', emitExamParam)
}
</script>

<style lang="scss" scoped>
.select-version {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5px;
    margin-bottom: 20px;

    @include breakpoint(black-bear) {
        padding-bottom: 308px;
        margin-bottom: 0px;
    }

    &__info {
        font-size: 14px;
        line-height: 17px;
        color: $ash;
        width: 303px;
        margin-bottom: 29px;
        text-align: center;
    }

    &__versions {
        width: 376px;
        max-width: calc(100% - 60px);
    }

    &__buttons {
        margin-top: 14px;
        display: flex;
        justify-content: space-around;
    }

    &__submit-arrow {
        margin-left: 8px;
    }

    &__phone-person {
        height: 312px;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: -1;

        @include breakpoint(black-bear) {
            height: 286px;
            bottom: -190px;
        }
    }
}
</style>
